export default "__VITE_ASSET__C8CpqH0z__"